// Cashback
export const CASHBACK = "SCOPE_FINANCE_CASHBACK";
export const CASHBACK_VIEW_LIVE_MONITORING = 'SCOPE_FINANCE_CASHBACK_VIEW_LIVE_MONITORING';
export const CASHBACK_VIEW_THRESHOLD = 'SCOPE_FINANCE_CASHBACK_VIEW_THRESHOLD';
export const CASHBACK_CONFIGURE_THRESHOLD = 'SCOPE_FINANCE_CASHBACK_CONFIGURE_THRESHOLD';
// Intermediaries
export const INTERMEDIARIES_VIEW_REPORTS = 'SCOPE_FINANCE_INTERMEDIARIES_VIEW_REPORTS';
export const INTERMEDIARIES_VIEW_PRINTOUTS = 'SCOPE_FINANCE_INTERMEDIARIES_VIEW_PRINTOUTS';
export const INTERMEDIARIES_CREATE_PRINTOUTS = 'SCOPE_FINANCE_INTERMEDIARIES_CREATE_PRINTOUTS';
export const INTERMEDIARIES_DOWNLOAD_REPORTS = 'SCOPE_FINANCE_INTERMEDIARIES_DOWNLOAD_REPORTS';
export const INTERMEDIARIES_DOWNLOAD_PRINTOUTS = 'SCOPE_FINANCE_INTERMEDIARIES_DOWNLOAD_PRINTOUTS';
// Royalties
export const VIEW_ROYALTIES_REPORTS = 'SCOPE_FINANCE_ROYALTIES_VIEW_REPORTS';
export const VIEW_PRINTOUTS_HISTORY = 'SCOPE_FINANCE_ROYALTIES_VIEW_PRINTOUTS_HISTORY';
export const CREATE_PRINTOUT = 'SCOPE_FINANCE_ROYALTIES_CREATE_PRINTOUT';
export const VIEW_REPORT_DETAIL = 'SCOPE_FINANCE_ROYALTIES_VIEW_REPORT_DETAIL';
export const DOWNLOAD_REPORT = 'SCOPE_FINANCE_ROYALTIES_DOWNLOAD_REPORT';
export const DOWNLOAD_PRINTOUT = 'SCOPE_FINANCE_ROYALTIES_DOWNLOAD_PRINTOUT';
export const PUBLISH_PRINTOUT = 'SCOPE_FINANCE_ROYALTIES_PUBLISH_PRINTOUT';
// Clusters
export const VIEW_CLUSTERS = 'SCOPE_FINANCE_CLUSTER_VIEW';
export const VIEW_CLUSTER_DETAIL = 'SCOPE_FINANCE_CLUSTER_VIEW_DETAIL';
export const ACTIVE_DEACTIVE_CLUSTER = 'SCOPE_FINANCE_CLUSTER_ACTIVE_DEACTIVE';
export const ADD_MS_TO_CLUSTER = 'SCOPE_FINANCE_CLUSTER_ADD_MS';
export const DELETE_CLUSTER = 'SCOPE_FINANCE_CLUSTER_DELETE';
export const ADD_VOICE_TO_CLUSTER = 'SCOPE_FINANCE_CLUSTER_ADD_VOICE';
export const EDIT_VOICE_CLUSTER = 'SCOPE_FINANCE_CLUSTER_EDIT_VOICE';
export const DELETE_VOICE_CLUSTER = 'SCOPE_FINANCE_CLUSTER_DELETE_VOICE';
export const ADD_FIXED_VOICE_TO_CLUSTER = 'SCOPE_FINANCE_CLUSTER_ADD_FIXED_VOICE';
export const EDIT_FIXED_VOICE_CLUSTER = 'SCOPE_FINANCE_CLUSTER_EDIT_FIXED_VOICE';
export const DELETE_FIXED_VOICE_CLUSTER = 'SCOPE_FINANCE_CLUSTER_DELETE_FIXED_VOICE';
export const EDIT_MS_CLUSTER = 'SCOPE_FINANCE_CLUSTER_EDIT';
export const DUPLICATE_MS_CLUSTER = 'SCOPE_FINANCE_CLUSTER_DUPLICATE';
export const CREATE_MS_CLUSTER = 'SCOPE_FINANCE_CLUSTER_CREATE';
export const CLUSTER_ADD_SUBSCRIPTION_CONFIGURATION = 'SCOPE_FINANCE_CLUSTER_ADD_SUBSCRIPTION_CONFIGURATION';
export const CLUSTER_EDIT_SUBSCRIPTION_CONFIGURATION = 'SCOPE_FINANCE_CLUSTER_EDIT_SUBSCRIPTION_CONFIGURATION';
// MS - Mobility Store
export const MS_VIEW_REPORTS = 'SCOPE_FINANCE_MS_VIEW_REPORTS';
export const MS_VIEW_PRINTOUTS = 'SCOPE_FINANCE_MS_VIEW_PRINTOUTS';
export const MS_CREATE_PRINTOUTS = 'SCOPE_FINANCE_MS_CREATE_PRINTOUTS';
export const MS_AUTOMATIC_BILLING = 'SCOPE_FINANCE_MS_AUTOMATIC_BILLING';
export const MS_VIEW_REPORT_DETAIL = 'SCOPE_FINANCE_MS_VIEW_REPORT_DETAIL';
export const MS_DOWNLOAD_REPORT = 'SCOPE_FINANCE_MS_DOWNLOAD_REPORT';
export const MS_REPROCESS_REPORT = 'SCOPE_FINANCE_MS_REPROCESS_REPORT';
export const MS_DELETE_REPORT = 'SCOPE_FINANCE_MS_DELETE_REPORT';
export const MS_PUBLISH_PRINTOUT = 'SCOPE_FINANCE_MS_PUBLISH_PRINTOUT';
export const MS_DOWNLOAD_PRINTOUT = 'SCOPE_FINANCE_MS_DOWNLOAD_PRINTOUT';
export const MS_REPROCESS_PRINTOUT = 'SCOPE_FINANCE_MS_REPROCESS_PRINTOUT';
export const MS_SEND_IN_INVOICING_MANUALLY = 'SCOPE_FINANCE_MS_SEND_IN_INVOICING_MANUALLY';
export const MS_DELETE_PRINTOUT = 'SCOPE_FINANCE_MS_DELETE_PRINTOUT';
// AMEXSOF
export const AMEXSOF_VIEW_CARDS = 'SCOPE_FINANCE_AMEXSOF_VIEW_CARDS';
export const AMEXSOF_ADD_CARD = 'SCOPE_FINANCE_AMEXSOF_ADD_CARD';
export const AMEXSOF_VIEW_CARD_DETAIL = 'SCOPE_FINANCE_AMEXSOF_VIEW_CARD_DETAIL';
export const AMEXSOF_EDIT_CARD = 'SCOPE_FINANCE_AMEXSOF_EDIT_CARD';
export const AMEXSOF_DELETE_CARD = 'SCOPE_FINANCE_AMEXSOF_DELETE_CARD';
export const AMEXSOF_REVOKE_CARD = 'SCOPE_FINANCE_AMEXSOF_REVOKE_CARD';
export const AMEXSOF_REACTIVE_CARD = 'SCOPE_FINANCE_AMEXSOF_REACTIVE_CARD';
export const AMEXSOF_VIEW_TRANSACTIONS = 'SCOPE_FINANCE_AMEXSOF_VIEW_TRANSACTIONS';
export const AMEXSOF_CREATE_TRANSACTION_REPORT = 'SCOPE_FINANCE_AMEXSOF_CREATE_TRANSACTION_REPORT';
export const AMEXSOF_VIEW_TRANSACTION_REPORT_DETAIL = 'SCOPE_FINANCE_AMEXSOF_VIEW_TRANSACTION_REPORT_DETAIL';
export const AMEXSOF_IMPORT_OUTCOMES = 'SCOPE_FINANCE_AMEXSOF_IMPORT_OUTCOMES';
export const AMEXSOF_DOWNLOAD_REPORT = 'SCOPE_FINANCE_AMEXSOF_DOWNLOAD_REPORT';
export const AMEXSOF_UPLOAD_PAYMENT_DATE_REPORT = 'SCOPE_FINANCE_AMEXSOF_UPLOAD_PAYMENT_DATE_REPORT';
// PAYMENT REQUEST
export const PAYMENT_REQUEST_VIEW = 'SCOPE_FINANCE_PAYMENT_REQUEST_VIEW';
export const PAYMENT_REQUEST_SM_VIEW = 'SCOPE_SM_REDIRECTING_FROM_SM_PAYMENT_LIST';
export const PAYMENT_REQUEST_VIEW_DETAIL = 'SCOPE_FINANCE_PAYMENT_REQUEST_VIEW_DETAIL';
export const PAYMENT_REQUEST_RESTORE = 'SCOPE_FINANCE_PAYMENT_REQUEST_RESTORE';
export const PAYMENT_REQUEST_RETRY = 'SCOPE_FINANCE_PAYMENT_REQUEST_RETRY';
export const PAYMENT_REQUEST_ADD_NOTE = 'SCOPE_FINANCE_PAYMENT_REQUEST_ADD_NOTE';
export const PAYMENT_REQUEST_ADD_AMOUNT = 'SCOPE_FINANCE_PAYMENT_REQUEST_ADD_AMOUNT';
export const PAYMENT_REQUEST_DOWNLOAD_XML = 'SCOPE_FINANCE_PAYMENT_REQUEST_DOWNLOAD_XML';
export const PAYMENT_REQUEST_OUTSTANDING = 'SCOPE_FINANCE_PAYMENT_REQUEST_OUTSTANDING';
export const PAYMENT_REQUEST_SUSPEND = 'SCOPE_FINANCE_PAYMENT_REQUEST_SUSPEND';
export const PAYMENT_REQUEST_ACCOUNTED = 'SCOPE_FINANCE_PAYMENT_REQUEST_ACCOUNTED';

//OUTSTANDING
export const OUTSTANDING_VIEW = 'SCOPE_FINANCE_OUTSTANDING_VIEW';
export const OUTSTANDING_VIEW_FROM_CB = 'SCOPE_VIEW_CUSTOMER_OUTSTANDINGS';
export const OUTSTANDING_VIEW_DETAIL = 'SCOPE_FINANCE_OUTSTANDING_VIEW_DETAIL';
export const OUTSTANDING_STATUS = 'SCOPE_FINANCE_OUTSTANDING_STATUS';
export const OUTSTANDING_SUSPEND = 'SCOPE_FINANCE_OUTSTANDING_SUSPEND';
export const OUTSTANDING_EXTERNAL_MANAGEMENT = 'SCOPE_FINANCE_OUTSTANDING_EXTERNAL_MANAGEMENT';
export const OUTSTANDING_ACCOUNTED = 'SCOPE_FINANCE_OUTSTANDING_ACCOUNTED';
export const OUTSTANDING_DOWNLOAD_XLS = 'SCOPE_FINANCE_OUTSTANDING_DOWNLOAD_XLS';
export const OUTSTANDING_ADD_NOTE = 'SCOPE_FINANCE_OUTSTANDING_ADD_NOTE';
export const OUTSTANDING_ADD_MASSIVE_NOTE = 'SCOPE_FINANCE_OUTSTANDING_ADD_MASSIVE_NOTE';
export const OUTSTANDING_ADD_AMOUNT = 'SCOPE_FINANCE_OUTSTANDING_ADD_AMOUNT';
// INVOICE
// RECEIVABLE
export const VIEW_RECEIVABLE = 'SCOPE_FINANCE_RECEIVABLE_VIEW';
export const VIEW_RECEIVABLE_DETAIL = 'SCOPE_FINANCE_RECEIVABLE_VIEW_DETAIL';
export const VIEW_RECEIVABLE_INSIGHT = 'SCOPE_FINANCE_RECEIVABLE_VIEW_INSIGHT';
export const DOWNLOAD_RECEIVABLE_PDF = 'SCOPE_FINANCE_RECEIVABLE_DOWNLOAD_PDF';
export const DOWNLOAD_RECEIVABLE_XML = 'SCOPE_FINANCE_RECEIVABLE_DOWNLOAD_XML';
export const CREATE_RECEIVABLE_VARIATION_NOTE = 'SCOPE_FINANCE_RECEIVABLE_CREATE_VARIATION_NOTE';
export const RECEIVABLE_LINKED_DOCUMENT = 'SCOPE_FINANCE_RECEIVABLE_LINKED_DOCUMENT';
export const RECEIVABLE_LINKED_DOCUMENT_DETAIL = 'SCOPE_FINANCE_RECEIVABLE_LINKED_DOCUMENT_DETAIL';
export const DOWNLOAD_RECEIVABLE_PDF_LINKED_DOCUMENT = 'SCOPE_FINANCE_RECEIVABLE_DOWNLOAD_PDF_LINKED_DOCUMENT';
export const DELETE_RECEIVABLE_LINKED_DOCUMENT = 'SCOPE_FINANCE_RECEIVABLE_DELETE_LINKED_DOCUMENT';
export const REISSUE_RECEIVABLE = 'SCOPE_FINANCE_RECEIVABLE_REISSUE';
export const REPROCESS_RECEIVABLE = 'SCOPE_FINANCE_RECEIVABLE_REPROCESS';
export const DELETE_RECEIVABLE = 'SCOPE_FINANCE_RECEIVABLE_DELETE';
// PAYABLE
export const VIEW_PAYABLE = 'SCOPE_FINANCE_PAYABLE_VIEW';
export const REPROCESS_PAYABLE = 'SCOPE_FINANCE_PAYABLE_REPROCESS';
export const VIEW_PAYABLE_DETAIL = 'SCOPE_FINANCE_PAYABLE_VIEW_DETAIL';
export const DOWNLOAD_PAYABLE_PDF = 'SCOPE_FINANCE_PAYABLE_DOWNLOAD_PDF';
export const DOWNLOAD_PAYABLE_XML = 'SCOPE_FINANCE_PAYABLE_DOWNLOAD_XML';
export const DELETE_PAYABLE = 'SCOPE_FINANCE_PAYABLE_DELETE';
// ENELX
export const ENELX_VIEW_REPORTS = 'SCOPE_FINANCE_ENELX_VIEW_REPORTS';
export const ENELX_VIEW_HISTORY = 'SCOPE_FINANCE_ENELX_VIEW_HISTORY';
export const ENELX_IMPORT_REPORTS = 'SCOPE_FINANCE_ENELX_IMPORT_REPORTS';
export const ENELX_VIEW_REPORT_DETAIL = 'SCOPE_FINANCE_ENELX_VIEW_REPORT_DETAIL';
export const ENELX_DELETE_REPORT = 'SCOPE_FINANCE_ENELX_DELETE_REPORT';
export const ENELX_SEND_IN_INVOICING = 'SCOPE_FINANCE_ENELX_SEND_IN_INVOICING';
export const ENELX_DOWNLOAD_REJECTED = 'SCOPE_FINANCE_ENELX_DOWNLOAD_REJECTED';
export const ENELX_VIEW_CONFIGURATION = 'SCOPE_FINANCE_ENELX_VIEW_CONFIGURATION';
export const ENELX_UPDATE_CONFIGURATION = 'SCOPE_FINANCE_ENELX_UPDATE_CONFIGURATION';
//TOKENIZED CARDS
export const TOKENIZED_CARD_VIEW = 'SCOPE_FINANCE_TOKENIZED_CARD_VIEW';

export const SCOPE_FINANCE_REFUELLING_VIEW = 'SCOPE_FINANCE_REFUELLING_VIEW';
export const SCOPE_FINANCE_REFUELLING_EDIT = 'SCOPE_FINANCE_REFUELLING_EDIT';

